<template>
  <img
    :src="mimeTypeIcon"
    :alt="mimeType"
  />
</template>

<script setup lang="ts">
import { useFileDescription } from '@/composition/mime'

const { mimeType } = defineProps<{
  mimeType: string // application/pdf
}>()

const { mimeTypeIcon } = useFileDescription(() => mimeType)
</script>
